<template>
  <!-- 18 13 -->
  <!-- eslint-disable-next-line max-len -->
  <path d="M14.7 7.5H1c-.5 0-1-.4-1-1 0-.5.4-1 1-1h13.7l-3.8-3.9c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l5.4 5.5c.4.4.4 1 0 1.4l-5.4 5.5c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l3.8-3.7z"/>
</template>
